module.exports = __webpack_public_path__ + "img/btn-btn-arrow-b.6220a2b1.svg";